import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login/login.service';
import { AuthService } from './services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})


export class AuthGuard implements CanActivate {
    validateLoginForm: FormGroup;
    constructor(private router: Router, private loginService: LoginService, private authService: AuthService,
        private form: FormBuilder) {
        
     }
    canActivate(
        
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

            if(next.queryParams.token){

                
                this.loginService.validateTokenInArchar(next.queryParams.token).subscribe((resData: any) => {

                    if (resData.status) {
                        this.validateLoginForm = this.form.group({
                            username: [resData.data.userID, Validators.required],
                            password: [resData.data.password, Validators.required]
                          });
            
                          this.loginService.authenticateUser(this.validateLoginForm)
                    .subscribe((resData: any) => {

                      if (resData.status) {
                        localStorage.setItem('dsu_token', resData.data.token);
                        localStorage.setItem('dsu_roleId', resData.data.roleId);
                        localStorage.setItem('dsu_userId', resData.data.userID);
                        localStorage.setItem('dsu_userName', resData.data.userName.trim());
                        localStorage.setItem('dsu_roleCode', resData.data.roleCode);
                        localStorage.setItem('dsu_roleName', resData.data.roleName.trim());
                        localStorage.setItem('dsu_userType', resData.data.userType.trim());
                        
                        this.router.navigate(['DSU/DemoSampleAllocation']);
                        return true;
                      }
                      else {
                        //this.toastr.error('Password is not valid.');
                      }
                    }, error => {
                      console.log(error);
                    });
    
    
    
    
                }else{
                    alert("You don't have permission to view this page!");
                }
                }, error => {
                    console.log(error);
                  });
                
                
                
    
               // if (this.CheckPermissionOfPage(this.getResolvedUrl(next))) {
                // localStorage.setItem('dsu_token', 'uZVTLBCWcw33RIhvnbxTKxTxM2rKJ7YJrwyUXhXn');
                // localStorage.setItem('dsu_roleId', "43");
                // localStorage.setItem('dsu_userId', "FMC-0145");
                // localStorage.setItem('dsu_userName', "Nausaba Khatoon");
                // localStorage.setItem('dsu_roleCode', "Marketing Region Head");
                // localStorage.setItem('dsu_roleName', "RMH");
                // localStorage.setItem('dsu_userType', "Worker");
                   
               // }
            }
            else if (localStorage.getItem("dsu_userId")) {

            if (this.CheckPermissionOfPage(this.getResolvedUrl(next))) {
                return true;
            }
            {
                this.router.navigate(['/DSU/Login']);
                localStorage.clear();
                return false;
            }
        }
        
        else {
            this.router.navigate(['/DSU/Login']);
            localStorage.clear();
            return false;
        }
    }

    
    checkSession(): boolean {
        let flag: boolean = false;
        this.loginService.checkSession()
            .then((response) => {
                if (response != null) {
                    if (response == true) {
                        let userId = localStorage.getItem("dsu_userId");
                        sessionStorage.setItem("dsu_userId", userId)
                        let sessionUserId = sessionStorage.getItem("dsu_userId");
                        if (sessionUserId == null) {
                            this.router.navigate(['/DSU/Login']);
                            flag = false;
                        }
                    } else {
                        this.router.navigate(['/DSU/Login']);
                        flag = false;
                    }
                }
                else {
                    this.router.navigate(['/DSU/Login']);
                    flag = false;
                }

            },
                error => {
                    if (error.status === 401) {
                        this.router.navigate(['/DSU/Login']);
                        flag = false;
                    }
                    console.log(error);
                });

        return flag = true;
    }
    getResolvedUrl(route: ActivatedRouteSnapshot): string {
        return route.pathFromRoot
            .map(v => v.url.map(segment => segment.toString()).join('/'))
            .join('/').replace('//','/');
    }
    CheckPermissionOfPage(url: string) {
        let isValid = false;
        let userRoleId = localStorage.getItem('dsu_roleId');
        if (userRoleId == "28") {//Brand Manager[MKTG]
            if (url == "/DSU/DSCostApproval"
                || url == "/DSU/Dashboard"
                || url == "/DSU/AdditionalRequirement"
                || url == "/DSU/Profile"
                || url == "/DSU/FinalRequirement"
                || url == "/DSU/MISInventory"
                || url == "/DSU/DemoSampleMIS"
                || url == "/DSU/DSURequirementReport"

            ) {
                isValid = true;
            }
            else {
                isValid = false;
            }

        }
        else if (userRoleId == "42" ||userRoleId == "76" ) {//Regional Marketing Head[AMM/RMH]

            if (url == "/DSU/Dashboard"
                || url == "/DSU/AnnualRequirement"
                || url == "/DSU/AdditionalRequirement"
                || url == "/DSU/Profile"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else if (url == "/DSU/Inventory"
                || url == "/DSU/DemoSampleAllocation"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        //Zonal Marketing Head[ZMH],Division Marketing Head[DMH],SBU Marketing Head[SBUMH]
        else if (userRoleId == "43" || userRoleId == "39" || userRoleId == "44"|| userRoleId == "77") {
            if (url == "/DSU/Dashboard"
                || url == "/DSU/AnnualRequirement"
                || url == "/DSU/AdditionalRequirement"
                || url == "/DSU/Profile"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else if (url == "/DSU/Inventory"
                || url == "/DSU/FinalRequirement"
                || url == "/DSU/DemoSampleAllocation"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        //else if (userRoleId == "14") {//Super Distributor-HO Team[SDHO]
        else if (userRoleId == "52"){
            if (url == "/DSU/Dashboard"
                || url == "/DSU/Inventory"
                || url == "/DSU/DSDispatchtoSD"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/DSDispatchtoWarehouse"
                || url == "/DSU/DemoSampleAllocation"
                || url == "/DSU/MISInventory"
                   || url == "/DSU/DemoSampleMIS"
                || url == "/DSU/Profile") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        
        else if (userRoleId == "53" || userRoleId == "14") {//SD-WH Team[SDWH]

            if (url == "/DSU/Dashboard"
                || url == "/DSU/Inventory"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/DSDispatchtoSD"
                || url == "/DSU/DemoSampleAllocation"
                || url == "/DSU/MISInventory"
                   || url == "/DSU/DemoSampleMIS"
                || url == "/DSU/DSSDAcknowledge"
                || url == "/DSU/Profile") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        else if (userRoleId == "49") {//Demand Fulfilment Specialist[DFS]
            if (url == "/DSU/Dashboard"
                || url == "/DSU/Inventory"
                || url == "/DSU/DSDispatchtoSD"
                || url == "/DSU/Profile"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        else if (userRoleId == "56") {
            if (url == "/DSU/Dashboard"
                || url == "/DSU/AdditionalRequirement"
                || url == "/DSU/Profile"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else if (url == "/DSU/Inventory"
                || url == "/DSU/DemoSampleAllocation"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/MISInventory"   || url == "/DSU/DemoSampleMIS") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        else if (userRoleId == "36"){
            if (url == "/DSU/Dashboard"
                || url == "/DSU/Inventory"
                || url == "/DSU/FinalRequirement"
                || url == "/DSU/DSDispatchtoField"
                || url == "/DSU/MISInventory"
                || url == "/DSU/DemoSampleMIS"
                || url == "/DSU/Profile") {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        else if(userRoleId == "1"|| userRoleId=="37" || userRoleId == "75" ){
            isValid = true;

        }
        else {
            isValid = false
        }

        return isValid;
    }

    
}
